import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { PaymentActivityTrackingTypeEnum } from '../enums/payment-activity-tracking-type.enum';

/**
 *  Payment activity tracking DTO
 */
@CaslSubject(AppSubjectEnum.PAYMENT_ACTIVITY_TRACKING)
export class PaymentActivityTrackingDto extends BaseDto {
	paymentId!: number;
	type!: PaymentActivityTrackingTypeEnum;
	metadata!: Record<string, any>;
}
